define('views/blocks/paymentModeProviders/EdenredProviderView',['underscore', 'app', 'ApiRequest',
    'PaymentModeSelectionBoardView',
    'models/EdenredDataModel',
    'views/blocks/EdenredView',
    'template!blocks/payments/edenred',
],function(_, app, ApiRequest,
    PaymentModeSelectionBoardView,
    EdenredDataModel,
    EdenredView,
    edenredTemplate
){


    return PaymentModeSelectionBoardView.extend({
        name:'edenred',
        afterRender:function(){
            var view = this,
                subview = new EdenredView({$el:view.$('.payment-mode--dialog__inner')});
            view.listenTo(subview,'complete',function(){
                view.close();
            });
            view.attachView(subview);
        },
        renderInner:function(){
            return edenredTemplate({
                edenred:EdenredDataModel
            });
        },
    });
});
